import {
  LANG_ENGLISH,
  LANG_TURKISH} from "../constants/language";
import { SWITCH_LANGUAGE } from "../constants/actionTypes";

var userLang = (navigator.language) ?
navigator.language : navigator.userLanguage;  


const initialState = {
  Current: userLang.includes("tr") ? LANG_TURKISH :  LANG_ENGLISH
};

const Language = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_LANGUAGE:
      return {
        ...state,
        Current: action.payload
      };
    default:
      return state;
  }
};

export default Language;
